export default __webpack_public_path__ + "static/media/unacast-symbol-orange-rgb.a9bdfd9e.svg";